<template>
  <div class="items">
    <podcast
      v-for="item in list"
      :key="item.id"
      v-bind:container-width="containerWidth"
      v-bind:display-player-inline="displayPlayerInline"
      v-bind:drop-to-live="dropToLive"
      v-bind:index="$index"
      v-bind:podcast="item"
      v-bind:smc="smc"
      v-bind:use-m4a="useM4a"
      v-on:pauseothers="onPauseOthers($index)"
      v-ref:players
    ></podcast>
    <pagination
      v-bind:page-list="pageList"
      v-bind:category="category"
    ></pagination>
  </div>
</template>

<script>
import Pagination from './pagination';
import Podcast from './podcast';

export default {
  components: {
    Pagination,
    Podcast,
  },
  props: [
    'category',
    'containerWidth',
    'displayPlayerInline',
    'dropToLive',
    'list',
    'pageList',
    'smc',
    'useM4a',
  ],
  methods: {
    /**
     * Pause other players except for this one.
     * @param index
     */
    onPauseOthers(index) {
      this.$refs.players.forEach((player, pIndex) => {
        if (pIndex !== index) {
          player.pauseMedia();
        }
      });
    },

    pauseAll() {
      this.$refs.players.forEach(player => {
        // find the play/pause button and set prop to false
        const playPauseButton = player
          .$children
          .find(child => child.$options.name === 'play-pause');
        playPauseButton.isPlaying = false;

        player.pauseMedia();
      });
    },

    switchCategory(category) {
      // forward to parent
      this.$parent.switchCategory(category);
    },

    switchPage(page, currentCategory) {
      // forward to parent
      this.$parent.switchPage(page, currentCategory);
    },

    imageLoaded() {
      // forward to parent
      this.$parent.imageLoaded();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// podcast_list.vue?4019482f